import { useState, useEffect } from 'react';

export function useIsMobile(): boolean {
  const [m, setM] = useState<boolean>(typeof window !== "undefined" && window.innerWidth < 768);
  useEffect(() => {
    const h = () => setM(window.innerWidth < 768);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);
  return m;
}
